import { Box } from '@mui/material'
import { CredentialResponse, GoogleLogin } from '@react-oauth/google'
import React from 'react'

import { useThemeMode } from '../../contexts/ThemeContext'

interface GoogleSignInButtonProps {
  onSuccess: (credential: string) => void
  onError?: () => void
  text?: 'signin_with' | 'signup_with' | 'continue_with' | 'signin'
  type?: 'standard' | 'icon'
  logoAlignment?: 'left' | 'center'
}

const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({
  onSuccess,
  onError,
  text = 'continue_with',
  type = 'standard',
  logoAlignment = 'center',
}) => {
  const { resolvedMode } = useThemeMode()

  const handleSuccess = (response: CredentialResponse) => {
    if (response.credential) {
      onSuccess(response.credential)
    }
  }

  const handleError = () => {
    onError?.()
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        text={text}
        type={type}
        shape="pill"
        size="large"
        width={type === 'icon' ? undefined : '300'}
        theme={resolvedMode === 'dark' ? 'filled_black' : 'outline'}
        logo_alignment={logoAlignment}
      />
    </Box>
  )
}

export default GoogleSignInButton
